import locationService from '../../services/location'

const state = {
  currentLocation: null,
  isValidLocation: false
}

const mutations = {
  SET_CURRENT_LOCATION(state, location) {
    state.currentLocation = location
  },
  SET_IS_VALID_LOCATION(state, isValid) {
    state.isValidLocation = isValid
  }
}

const actions = {
  setCurrentLocation({ commit }, location) {
    commit('SET_CURRENT_LOCATION', location)
    
    // Check if location is valid
    const isValid = location && 
      location.lat !== undefined && 
      location.lng !== undefined && 
      (location.lat !== 0 || location.lng !== 0)
    
    commit('SET_IS_VALID_LOCATION', isValid)
  },
  updateLocation({ commit }, location) {
    commit('SET_CURRENT_LOCATION', location)
    
    // Check if location is valid
    const isValid = location && 
      location.lat !== undefined && 
      location.lng !== undefined && 
      (location.lat !== 0 || location.lng !== 0)
    
    commit('SET_IS_VALID_LOCATION', isValid)
  },
  startLocationWatching({ dispatch }) {
    // Start watching location and update store when location changes
    locationService.startWatching((location) => {
      dispatch('updateLocation', location)
    })
  },
  stopLocationWatching() {
    locationService.stopWatching()
  }
}

const getters = {
  currentLocation: state => state.currentLocation,
  isValidLocation: state => state.isValidLocation
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
} 